import React from "react";
import { Box, Center, Button, useBoolean } from "@chakra-ui/react";
import { MyModal } from "../../common/MyModal";
import { ImageModal } from "./ImageModal";

export function ImageUploadButton({
  callback,
  submitDisabled,
  background = "brand.blue",
  hoverBackground = "brand.lightBlue",
}: Props) {
  const [imageModalOpen, setImageModalOpen] = useBoolean(false);
  const [imageSelected, setImageSelected] = useBoolean(false);

  const setImageFunction = (image: Blob) => {
    setImageSelected.on();
    callback(image);
  };

  return (
    <Box>
      <Center>
        <Button
          background={background}
          onClick={setImageModalOpen.on}
          disabled={submitDisabled}
          _hover={{ background: hoverBackground }}
        >
          Upload Image
        </Button>
      </Center>
      <MyModal
        isOpen={imageModalOpen}
        onClose={setImageModalOpen.off}
        title="Edit Image"
        size="4xl"
      >
        <ImageModal
          setImage={setImageFunction}
          setClose={setImageModalOpen.off}
          background={background}
        />
      </MyModal>
    </Box>
  );
}

interface Props {
  callback: (image: Blob) => void;
  submitDisabled: boolean;
  background?: string;
  hoverBackground?: string;
}
